import { Pipe, PipeTransform } from '@angular/core';
import { FilterMetadata } from 'primeng/api';

@Pipe({
  name: 'valueFromFiltermetadata'
})
export class ValueFromFiltermetadataPipe implements PipeTransform {
  transform(input: FilterMetadata | FilterMetadata[]): string {
    if (input) {
      if (Array.isArray(input)) {
        return input[0].value;
      } else {
        return input.value;
      }
    } else {
      return undefined;
    }
  }
}
